import {
    Component,
    ChangeDetectorRef,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    OnChanges,
    SimpleChanges,
    OnDestroy,
    HostListener
} from "@angular/core";
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
} from "@angular/forms";
import { MessageModalComponent } from "@niceltd/cxone-components/modal";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { Subject, Subscription } from "rxjs";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import {
    ComparisonObject,
    ContactGroupPayload,
    DatesParentDataType,
    DefaultConfigurationData,
    ETLReportingSetComparisonTypes,
    ETLReportingSetDateOperationTypes,
    ETLReportingSetDropdownOptions,
    ETLReportingSetFieldTypesId,
    ETLReportingSetFlowbuilderModules,
    ETLReportingSetFunctionTypes,
    ETLReportingSetJoinedFeedsList,
    ETLReportingSetObj,
    ETLReportingSetOperationTypes,
    ETLReportingSetReturnTypes,
    ETLReportingSetSimpleFieldReturnOptions,
    EmployeeGroupListType,
    EmployeeGroupPayload,
    FunctionComponentType,
    FunctionPayloadType,
    HierarchyGroup,
    ParentOutputFormType,
    ReportingSetFieldPayload,
    ReportingSetSections,
    RowDataObj,
    SimpleFieldModalType,
    ETLExcludeIf,
    ETLPayloadTypes,
    ComparisonTypes,
    STATUS,
    EMPHIERARCHY,
    CONTACTHIERARCHY,
    EMPHIERARCHYKEY,
    CONTACTHIERARCHYKEY,
    HierarchySourceSystem,
    ConvertFieldTypes,
    DataFlowSubFields,
    PERMISSION
} from "../../cxone-etl-reporting-set.model";
import { CxoneEtlReportingSetService } from "../../cxone-etl-reporting-set.service";
import { AddSimpleFeedModalComponent } from '../add-simple-feed-modal/add-simple-feed-modal.component';
import { CxoneEtlReportingSetJoinedFeedComponent } from "../cxone-etl-reporting-set-joined-feed/cxone-etl-reporting-set-joined-feed.component";
import { CxoneReportingSetDataFieldComponent } from "../cxone-reporting-set-data-field/cxone-reporting-set-data-field.component";
import { TreeBuilderComponent } from "../tree-builder/tree-builder.component";
import { EmployeeGroupComponent } from "./employee-group/employee-group.component";
import { ContactGroupComponent } from "./contact-group/contact-group.component";
import { ToastrManager } from "@niceltd/cxone-components/toastr";
import { AfterContentChecked } from "cv-ng-metadata/core";
@Component({
    selector: "cv-cxone-reporting-set-flow-builder",
    templateUrl: "./cxone-reporting-set-flow-builder.component.html",
    styleUrls: ["./cxone-reporting-set-flow-builder.component.scss"],
    providers: [DialogService]
})
export class CxoneReportingSetFlowBuilderComponent implements OnInit, AfterContentChecked, OnChanges, OnDestroy {
    @Output() public sectionChange = new EventEmitter<ReportingSetSections>();
    rootForm: FormGroup;
    public newReportingSetPayload: ETLReportingSetObj & ReportingSetFieldPayload;
    public reportingSetSections = ReportingSetSections;
    public showSpinner = false;
    public isConfigurationPaneActive = false;
    public isJoinFeedPaneActive = false;
    public joinedFeedsHeader = "";
    public datesHeader = "";
    public dataFieldsHeader = "";
    public employeeGroupHeader = "";
    public contactGroupHeader = "";
    public excludeIfHeader = "";
    public selectedSection = "";
    @Input() reportingSetForm: any;
    @Input() isShowFlowBuilder: boolean;
    public reportingSetName = "";
    public category = "";
    public description = "";
    @ViewChild(CxoneEtlReportingSetJoinedFeedComponent)
    reportingSetJoined: CxoneEtlReportingSetJoinedFeedComponent;
    @ViewChild(EmployeeGroupComponent)
    employeeGroupComponent: EmployeeGroupComponent;
    @ViewChild(ContactGroupComponent)
    contactGroupComponent: ContactGroupComponent;
    @ViewChild(CxoneReportingSetDataFieldComponent)
    reportingSetDataFieldComponent: CxoneReportingSetDataFieldComponent;
    @ViewChild(TreeBuilderComponent)
    treeBuilderComponent: TreeBuilderComponent;
    public reportingSetJoinedFeedsList: ETLReportingSetJoinedFeedsList[] = [];
    public joinFeedFormValid = false;
    public reportingSetNameStyle = "";
    public sourceSystem = "";
    setjoinedFeedFormData: ETLReportingSetJoinedFeedsList;
    cancelAlertSubj = new Subject();
    cancelSubjRef: Subscription;
    protected readonly flowbuilderModules = ETLReportingSetFlowbuilderModules;
    public contactGroupPayload: ContactGroupPayload = null;
    public employeeGroupPayload: EmployeeGroupPayload = null;
    public feedName = "";
    public simpleFeedOptionList: ETLReportingSetDropdownOptions[] = [];
    public reportingSetFieldPayload: ReportingSetFieldPayload & ETLReportingSetObj;
    public payloadData: ParentOutputFormType;
    public parentOutputForm: ParentOutputFormType = {};
    public selectedSectionItem = '';
    public modalRef: DynamicDialogRef = null;
    public isAdvanced = false;
    public datesList: RowDataObj[] = [];
    @Input() set dataFieldsList(data: any) {
        this._dataFieldsList = data;
        this.assignDatafieldsData(data);
    }
    public defaultConfigurationData: DefaultConfigurationData | {} = {};
    public dataFieldsObjList: ParentOutputFormType[] = [];
    public dataFieldNamesList: string[] = [];
    public datesFieldsObjList: ParentOutputFormType[] = [];
    public datesFieldNamesList: string[] = [];
    public employeeGrpObjList: ParentOutputFormType[] = [];
    public employeeGrpNamesList: string[] = [];
    public contactGrpObjList: ParentOutputFormType[] = [];
    public contactGrpNamesList: string[] = [];
    private UNIQUE_ID = 0;
    public parentPayload = null;
    public saveDisabled = true;
    public createDisabled = true;
    private resetDataField = new Subject<void>();
    public resetClick$ = this.resetDataField.asObservable();
    public currentClickedField = '';
    public _dataFieldsList: RowDataObj[];
    public isModalClosed = false;
    private prevSource = '';
    public excludeIf = true;
    public excludeIfSection: ETLExcludeIf;
    public employeeGrpSubject: Subject<EmployeeGroupPayload> = new Subject();
    public selectedEmployeeGroup = '';
    public selectedContactGroup = '';
    public hierarchyGroupClickedItem: any;
    public hierarchyEmployeeGroupClickedItem: any;
    @Input() updateBtnVisiblity: boolean;
    public groupsValidationCheck = {
        employee: [],
        contact: []
    };
    public fieldNames: string[];
    public fieldsList: ParentOutputFormType[];
    public comparisonTypes = ComparisonTypes;
    public isClose = false;
    public subscriptions: Subscription[] = [];
    public showTreebuilder = true;
    private employeeItemSaved = {
        Company: false,
        Agent: false,
        Team: false
    };
    private contactItemSaved = {
        Company: false,
        Campaign: false,
        PointofContact: false,
        Skill: false
    };
    public isSaving = false;
    public isUpdateBtnEnable = true;
    joinedfeedCurrentItem: ETLReportingSetJoinedFeedsList[] = [];
    @Input() permissions: string[];
    public canEditLocked = false;
    public canEdit = false;

    @HostListener('window:resize', ['$event'])
    onResize(e: any) {
        this.buildTreeFromForm();
    }

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private fb: FormBuilder,
        private dialogSrvc: DialogService,
        public cxoneEtlReportingSet: CxoneEtlReportingSetService,
        private elementRef: ElementRef,
        private toasterManager: ToastrManager,
        private cdRef: ChangeDetectorRef
    ) { }

    ngAfterContentChecked() {
        this.cdRef.detectChanges();
    }

    get dataFieldsList() {
        return this._dataFieldsList;
    }

    async ngOnInit() {
        this.canEditLocked = this.permissions?.includes(PERMISSION.ADMIN);
        this.canEdit = this.permissions?.includes(PERMISSION.EDIT);
        this.rootForm = this.fb.group({
            nestedDataFields: this.fb.array([]),
        });
        this.addInitialDataField();
        this.showSpinner = true;
        await this.loadLocalization();
        this.initializeNewReportingSetPayload();
        this.loadFieldsInAllCategories();
        this.showSpinner = false;
        this.excludeIf = !this.reportingSetForm?.editReportingSetData?.hasOwnProperty("ExcludeIf");
        this.verifyGroups();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateReportingSetInfo();
        this.selectedSection = ETLReportingSetFlowbuilderModules.DEFAULT;
        this.isConfigurationPaneActive = false;
    }

    ngOnDestroy(): void {
        this.declineAllSubscriptions();
    }

    public initializeNewReportingSetPayload() {
        this.newReportingSetPayload = {
            ReportingSetName: this.reportingSetName,
            ReportingSetDescription: this.reportingSetForm.description,
            ReportingSetGroup: this.category,
            BaseFeed: this.reportingSetForm.basefeed.FeedName,
            BaseSourceSystem: this.sourceSystem,
            Mode: 0,
            QueuedOnImport: this.reportingSetForm.basefeed.QueuedOnImport,
            Type: 0,
            Dates: {},
            Joins: [],
            EmpHierarchy: {},
            ContactHierarchy: {},
            Attributes: {},
            DataFields: {},
            ExcludeIf: {},
            IsApiSourced: false,
            _id: this.reportingSetForm.basefeed._id,
            Status: this.reportingSetForm.basefeed.Status,
            IsEditable: this.reportingSetForm.basefeed.IsEditable,
            IsViewable: true,
            IsTemplate: false,
            TimeToLive: 0,
            preexisting: true,
            lastRunDisplay: "None",
            lastRunCellClass: null,
        };
    }

    addInitialDataField() {
        if (this.rootForm) {
            const nestedFormsArray = this.rootForm.get(
                "nestedDataFields"
            ) as FormArray;
            const initialField = new FormGroup({
                name: new FormControl(""),
                fieldType: new FormControl(),
                returnType: new FormControl(),
                nestedDataFields: new FormArray([]),
            });
            nestedFormsArray.push(initialField);
        }
        this.updateReportingSetInfo();
        this.addReportingsetJoinedFeeds(false);
    }

    updateReportingSetInfo(): void {
        this.reportingSetName = this.reportingSetForm.reportingSetName;
        this.category = this.reportingSetForm.category.name;
        this.sourceSystem = this.reportingSetForm.basefeed.SourceSystem;
        this.feedName = this.reportingSetForm.basefeed.FeedName;
        this.description = (
            this.feedName.replace(/\s+/g, "") +
            "(" +
            this.sourceSystem +
            ")"
        ).toUpperCase();
        this.reportingSetNameStyle = this.hasWhiteSpace(this.reportingSetName)
            ? ``
            : `text-overflow: ellipsis; white-space: nowrap; overflow: hidden;`;
        this.simpleFeedOptionList = [
            { id: 0, label: this.feedName + " (" + this.sourceSystem + ")", joinKeyMap: -1 },
        ];
    }

    public changeSection(section: number): void {
        if (this.checkIsFormChanged(true, section) === false) {
            if (this.reportingSetJoinedFeedsList.length || this.datesFieldNamesList.length || this.dataFieldNamesList.length) {
                this.isClose = true;
                this.showAlertMessage(true, section);
            } else {
                this.sectionChange.emit(section);
            }
        }
    }

    public async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection("ETL_Reporting_Set");
        } catch {
            console.log("Failed to load localization for ETL_Reporting_Set");
        } finally {
            this.setDataCountAndCollapseHeader();
            this.employeeGroupHeader = this.getLocalizationString("Employee_Group", "EMPLOYEE GROUP");
            this.contactGroupHeader = this.getLocalizationString("Contact_Group", "CONTACT GROUP");
            this.excludeIfHeader = this.getLocalizationString("Exclude_If", "EXCLUDE IF");
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        return this.cvLocalizationService.getCachedText("ETL_Reporting_Set", key, defaultValue);
    }

    addSection(source: string, isNew = true): void {
        this.employeeGroupPayload = null;
        this.contactGroupPayload = null;
        this.hierarchyGroupClickedItem = null;
        this.hierarchyEmployeeGroupClickedItem = null;
        this.configurePaneActive();
        this.currentClickedField = '';
        this.parentPayload = null;
        this.excludeIfSection = null;
        this.declineAllSubscriptions();
        let formChanged = this.reportingSetJoined?.reportingSetJoinedFeed.dirty || this.reportingSetDataFieldComponent?.dataFieldForm.dirty;
        switch (source) {
            case this.flowbuilderModules.JOINED_FEEDS:
                this.isJoinFeedPaneActive = true;
                if (isNew) {
                    if (this.checkIsFormChanged() === false) {
                        this.selectedSection = source;
                        this.setjoinedFeedFormData = {};
                    }
                    this.selectedSectionItem = 'new';
                    sendMessageCXOne({ hasNonSavedChanges: true });
                } else {
                    this.selectedSection = source;
                    this.isConfigurationPaneActive = false;
                    this.setjoinedFeedFormData = { ...this.setjoinedFeedFormData };
                }
                break;
            case this.flowbuilderModules.EXCLUDE_IF:
                this.selectedSection === source;
                this.isConfigurationPaneActive = true;
            default:
                this.prevSource = source;
                if (source !== this.flowbuilderModules.DEFAULT) {
                    if (this.checkIsFormChanged() === false) {
                        this.selectedSection = source;
                    }
                    if (!formChanged) {
                        this.showDataFields(source);
                    }
                    sendMessageCXOne({ hasNonSavedChanges: true });
                } else {
                    this.selectedSection = source;
                }
        }
        this.cancelSubjRef = this.cancelAlertSubj.subscribe(() => {
            if (formChanged && !this.isClose) {
                this.isConfigurationPaneActive = false;
                if (isNew && source == this.flowbuilderModules.JOINED_FEEDS) {
                    this.selectedSection = source;
                    this.setjoinedFeedFormData = {};
                } else {
                    this.selectedSection = this.flowbuilderModules.DEFAULT;
                    this.showDataFields(this.prevSource);
                }
                this.prevSource = '';
                isNew = false;
                this.isClose = false;
            }
        });
        this.subscriptions.push(this.cancelSubjRef);
    }

    private showDataFields(source: string): void {
        if (source === this.flowbuilderModules.DATES) {
            this.showSimpleFieldsModal(["Add_Simple_Date_Fields", "Add Simple Date Fields"], source, "Date");
        } else if (source === this.flowbuilderModules.DATA_FIELDS) {
            this.showSimpleFieldsModal(["Add_Simple_Fields", "Add Simple Fields"], source);
        }
    }

    addReportingsetJoinedFeeds(saveLocal) {
        if (
            this.reportingSetForm.hasOwnProperty("editReportingSetData") &&
            !saveLocal
        ) {
            const joins = this.reportingSetForm.editReportingSetData.Joins.map(
                (join, joinId) => {
                    const item = {
                        joinedFeedName: join.JoinName,
                        joinKeyMap: join.JoinKey.MapsToJoinID,
                        JoinID: join.JoinID,
                        checkbox: join.Required,
                        feed1: {
                            id: joinId,
                            name:
                                join.JoinKey.MapsToJoinID === -1
                                    ? this.reportingSetForm.basefeed.FeedName +
                                    " (" +
                                    this.sourceSystem +
                                    ")"
                                    : this.reportingSetForm.editReportingSetData
                                        .Joins[join.JoinKey.MapsToJoinID]
                                        .JoinName,
                        },
                        feed2: {
                            dropdownOptions:
                                join.FeedName + " (" + join.SourceSystem + ")",
                            _id:
                                join.JoinID +
                                "|" +
                                join.FeedName +
                                "|" +
                                join.SourceSystem +
                                "|RawDataDefinition",
                            CompanyID: join.JoinID,
                            FeedName: join.FeedName,
                            SourceSystem: join.SourceSystem,
                            DataList: join.JoinKey.EvalFields.map(
                                (field, i) => ({
                                    Name: field,
                                    id: i,
                                })
                            ),
                        },
                        joinedFields: join.JoinKey.MapsToFields.map(
                            (field, i) => ({
                                field1: {
                                    dropdownOptions: field,
                                    Name: field,
                                },
                                field2: {
                                    dropdownOptions: join.JoinKey.EvalFields[i],
                                    Name: join.JoinKey.EvalFields[i],
                                },
                            })
                        ),
                        filterComparedSText: {
                            field1: join.JoinKey?.LeftFeedFilters ? Object.entries(
                                join.JoinKey?.LeftFeedFilters
                            ).map(([key, value]) => key + " = " + value[0]) : [],
                            field2: join.JoinKey?.RightFeedFilters ? Object.entries(
                                join.JoinKey?.RightFeedFilters
                            ).map(([key, value]) => key + " = " + value[0]) : [],
                        },
                    };
                    return item;
                }
            );

            this.reportingSetJoinedFeedsList = [...joins];
        } else if (this.reportingSetJoined) {
            let reportingSetJoinedFeed = this.reportingSetJoined?.reportingSetJoinedFeed.value;
            const filterComparedSText = this.reportingSetJoined?.filterComparedSText;
            for (const key in reportingSetJoinedFeed) {
                if (key.startsWith("filterField")) {
                    delete reportingSetJoinedFeed[key];
                }
            }
            filterComparedSText.field1 = [...new Set(filterComparedSText?.field1)];
            filterComparedSText.field2 = [...new Set(filterComparedSText?.field2)];
            reportingSetJoinedFeed["filterComparedSText"] = filterComparedSText;
            this.joinedfeedCurrentItem = reportingSetJoinedFeed
            const index = this.reportingSetJoinedFeedsList.findIndex(
                (feed) =>
                    feed.joinedFeedName ===
                    this.setjoinedFeedFormData.joinedFeedName
            );
            if (index !== -1) {
                this.reportingSetJoinedFeedsList[index] = reportingSetJoinedFeed;
            } else {
                this.reportingSetJoinedFeedsList.push(reportingSetJoinedFeed);
            }
        }
        this.addSection(this.flowbuilderModules.DEFAULT);
        this.setDataCountAndCollapseHeader();
        this.createReportingSet();
    }

    setjoinedFeedData(item: any) {
        this.currentClickedField = '';
        this.declineAllSubscriptions();
        if (this.checkIsFormChanged() === false) {
            this.setJoinedFeed(item);
        }
        this.cancelSubjRef = this.cancelAlertSubj.subscribe(() => {
            this.setJoinedFeed(item);
        });
        this.subscriptions.push(this.cancelSubjRef);
        if (this.isJoinFeedPaneActive) {
            this.isJoinFeedPaneActive = false;
            setTimeout(() => {
                this.isJoinFeedPaneActive = true;
            }, 0);
        }
        setTimeout(() => {
            this.isJoinFeedPaneActive = true;
        }, 0);
    }

    setJoinedFeed(item) {
        this.setjoinedFeedFormData = item;
        this.selectedSectionItem = item.joinedFeedName;
        this.addSection(this.flowbuilderModules.JOINED_FEEDS, false);
    }

    onJoinFeedForms(valid: boolean) {
        this.joinFeedFormValid = valid;
        this.handleSaveBtn(valid);
    }

    hasWhiteSpace(text: string) {
        return /\s/.test(text);
    }

    checkIsFormChanged(goBack = false, page = this.reportingSetSections.LIST) {
        if (this.reportingSetJoined?.reportingSetJoinedFeed.dirty || this.reportingSetDataFieldComponent?.dataFieldForm.dirty) {
            this.showAlertMessage(goBack, page);
            return true;
        } else {
            return false;
        }
    }

    public showAlertMessage(goBack: boolean, page = this.reportingSetSections.LIST) {
        const dialogData = {
            title: this.getLocalizationString("Leave_Without_Saving", "Leave without saving?"),
            type: "user-warning",
            message: `<div class="msg-line-1" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Cancel_Modal_Lost_Changes"> All changes will be lost. </div>`,
            primaryButtonText: this.getLocalizationString("Leave", "Leave"),
            closeButtonText: this.getLocalizationString("Stay", "Stay"),
        };

        const ref = this.dialogSrvc.open(MessageModalComponent, {
            width: "420px",
            height: "184px",
            styleClass: "cx-one-ui modal-center testing",
            data: dialogData,
        });

        ref.onClose.subscribe((x) => {
            if (x) {
                this.cancelAlertSubj.next(true);
                if (goBack) {
                    this.sectionChange.emit(page);
                }
            }
        });
    }

    createReportingSet(): void {
        let joinId = 0;
        const joinsObj = { Joins: [] };

        this.reportingSetJoinedFeedsList.forEach((item, index) => {
            const join = this.createJoin(joinId, item);
            joinId++;
            joinsObj.Joins.push(join);
            item['JoinID'] = index;
        });

        joinsObj.Joins.forEach((join, i) => {
            join.JoinKey.MapsToJoinID = this.findMapsToJoinID(i);
        });

        if (this.reportingSetForm.hasOwnProperty("editReportingSetData")) {
            this.reportingSetFieldPayload = { ...this.reportingSetFieldPayload, ...joinsObj };
        } else {
            this.newReportingSetPayload = { ...this.newReportingSetPayload, ...joinsObj };
            this.reportingSetFieldPayload = this.newReportingSetPayload;
        }
    }

    createJoin(joinId, item) {
        const join = {
            JoinKey: {
                EvalFields: [],
                MapsToFields: [],
                MapsToCompanyID: 0,
                LeftFeedFilters: {},
                RightFeedFilters: {},
            },
        };

        if (joinId < this.reportingSetJoinedFeedsList.length) {
            join["JoinName"] = this.reportingSetJoinedFeedsList[joinId].joinedFeedName;
            join["Required"] = this.reportingSetJoinedFeedsList[joinId].checkbox;
            join["JoinID"] = joinId;
            join["FeedName"] = this.reportingSetJoinedFeedsList[joinId].feed2.FeedName;
            join["SourceSystem"] = this.reportingSetJoinedFeedsList[joinId].feed2.SourceSystem !== undefined ? this.reportingSetJoinedFeedsList[joinId].feed2.SourceSystem : HierarchySourceSystem;
        }
        const field1 = item.filterComparedSText.field1;
        const field2 = item.filterComparedSText.field2;
        join.JoinKey.MapsToFields = item.joinedFields.map(
            (field) => field.field1.key !== undefined ? field.field1.key : field.field1.Name
        );
        join.JoinKey.EvalFields = item.joinedFields.map(
            (field) => field.field2.key !== undefined ? field.field2.key : field.field2.Name
        );
        join.JoinKey.MapsToCompanyID = item.feed2.CompanyID;
        join.JoinKey.LeftFeedFilters = this.createFilters(field1);
        join.JoinKey.RightFeedFilters = this.createFilters(field2);

        return join;
    }

    createFilters(field) {
        const filters = {};
        field.forEach((str) => {
            const [key, value] = str.split(" = ");
            filters[key] = filters[key] || [];
            filters[key].push(value);
        });
        return filters;
    }

    findMapsToJoinID(i) {
        for (let j = i - 1; j >= 0; j--) {
            if (
                this.reportingSetJoinedFeedsList[i].feed1.name ===
                this.reportingSetJoinedFeedsList[j].joinedFeedName
            ) {
                return j;
            }
        }
        return -1;
    }

    public getContactGroupData(event: EmployeeGroupListType) {
        let grpDataLength = Object.keys(event.GroupData).length;
        if (grpDataLength === 1) { //edit Employee Group
            this.backtrackReportingPayload(event, this.flowbuilderModules.CONTACT_GROUP, Object.keys(event.GroupData)[0]);
        } else {
            const obj = { group: this.flowbuilderModules.CONTACT_GROUP, selectedItem: event.GroupTypeName };
            this.backtrackReportingPayload({ obj: obj, contactGroupData: event.GroupData as HierarchyGroup }, obj.selectedItem, ETLReportingSetFlowbuilderModules.CONTACT_GROUP);
        }
    }


    public getEmployeeHierarchyData(event: EmployeeGroupListType) {
        let grpDataLength = Object.keys(event.GroupData).length;
        if (grpDataLength === 1) { //edit Employee Group
            this.backtrackReportingPayload(event, this.flowbuilderModules.EMPLOYEE_GROUP, Object.keys(event.GroupData)[0]);
        } else { // clicked for the first time
            const obj = { group: this.flowbuilderModules.EMPLOYEE_GROUP, selectedItem: event.GroupTypeName };
            this.backtrackReportingPayload({ obj: obj, employeeHierarchyData: event.GroupData as HierarchyGroup }, obj.selectedItem, this.flowbuilderModules.EMPLOYEE_GROUP);
        }
    }

    public async initializeReportingSetPayload(selectedSection = this.selectedSection) {
        const compareGroups = (order: string[]) => {
            return (a: { [key: string]: any }, b: { [key: string]: any }): number => {
                const keyA = Object.keys(a)[0];
                const keyB = Object.keys(b)[0];
                return order.indexOf(keyA) - order.indexOf(keyB);
            };
        };
        if (selectedSection === "dataFields") {
            let dataFields = {};
            this.dataFieldsObjList?.forEach(item => {
                let key = Object.keys(item)[0];
                dataFields[key] = item[key];
            });
            this.reportingSetFieldPayload.DataFields = { ...dataFields };
        } else if (selectedSection === "dates") {
            let datesFields = {};
            this.datesFieldsObjList?.forEach(item => {
                let key = Object.keys(item)[0];
                datesFields[key] = item[key];
            });
            this.reportingSetFieldPayload.Dates = { ...datesFields };
        } else if (selectedSection === this.flowbuilderModules.EMPLOYEE_GROUP) {
            let employeeGrp = {};
            this.employeeGrpObjList.sort(compareGroups(EMPHIERARCHY));
            this.employeeGrpObjList.forEach(item => {
                let key = Object.keys(item)[0];
                employeeGrp[key] = item[key];
            });
            const updatedEmpHierarchy = this.mapKeyInObject(employeeGrp, ETLReportingSetFlowbuilderModules.EMPLOYEE_GROUP, true);
            this.reportingSetFieldPayload.EmpHierarchy = { ...updatedEmpHierarchy };
        } else if (selectedSection === this.flowbuilderModules.CONTACT_GROUP) {
            let contactGrp = {};
            this.contactGrpObjList.sort(compareGroups(CONTACTHIERARCHY));
            this.contactGrpObjList.forEach(item => {
                let key = Object.keys(item)[0];
                contactGrp[key] = item[key];
            });
            const updatedContactHierarchy = this.mapKeyInObject(contactGrp, ETLReportingSetFlowbuilderModules.CONTACT_GROUP, true);
            this.reportingSetFieldPayload.ContactHierarchy = { ...updatedContactHierarchy };
        } else if (selectedSection === ETLReportingSetFlowbuilderModules.EXCLUDE_IF) {
            this.reportingSetFieldPayload = { ...this.reportingSetFieldPayload, ...this.parentOutputForm };
        }
    }

    public initOutputPayload(payload: any) {
        this.payloadData = payload;
        this.parentPayload = null;
    }

    public createFieldPayloadObject(payload: any) {
        const { child, name, returnType } = payload;
        this.parentOutputForm[name] = this.getChildObj(child, returnType.id || 0);
    }

    public getChildObj(childs: any, expectedType: number, index = 0): object {
        let fieldType: string;
        let children;

        if (Array.isArray(childs)) {
            if (childs.length) {
                fieldType = childs[index].type || "";
                children = childs[index].childs || [];
            } else {
                fieldType = "";
                children = [];
            }
        } else {
            fieldType = childs.type;
            children = childs.childs;
        }

        switch (fieldType) {
            case "Substring":
                // keeping an or operator because for the first iteration childs will be an object
                const { pattern } = childs[index] || childs;
                return {
                    Pattern: pattern,
                    ExpectedType: expectedType,
                    Input: this.getChildObj(children, expectedType),
                };
            case "Simple":
                const simpleFieldType = childs[index]?.simpleFieldType || childs.simpleFieldType;
                const { JoinID, Field, UseNow } = simpleFieldType;
                const returnId = simpleFieldType.return.id;
                const fieldName = Field?.key || Field?.Name || "";
                const defaultValue = simpleFieldType.DefaultValue;

                if (returnId === ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD) {
                    return {
                        JoinID: "joinID" in JoinID ? JoinID.joinID : -1,
                        ExpectedType: simpleFieldType.expectedReturnType?.id || simpleFieldType.expectedReturnType,
                        Field: fieldName,
                    };
                } else if (returnId === ETLReportingSetSimpleFieldReturnOptions.DEFAULT_VALUE) {
                    const convertedDefaultValue = defaultValue ? this.convertAndSend(defaultValue) : defaultValue;
                    let simpleFielDefaultValueObj = {
                        IsNull: simpleFieldType?.IsNull || false,
                        JoinID: "joinID" in JoinID ? JoinID.joinID : -1,
                        ExpectedType: simpleFieldType.expectedReturnType?.id || simpleFieldType.expectedReturnType,
                        DefaultValue: simpleFieldType?.IsNull ? null : convertedDefaultValue
                    }
                    const expectedReturnid = simpleFieldType.expectedReturnType?.id || simpleFieldType.expectedReturnType;
                    if (expectedReturnid === ETLReportingSetReturnTypes.DATE) {
                        // UseNow should be added only for Dates return type
                        simpleFielDefaultValueObj['UseNow'] = UseNow;
                        simpleFielDefaultValueObj.DefaultValue = simpleFieldType?.IsNull ?
                            null : defaultValue == "{{NOW}}" ?
                                defaultValue : new Date(defaultValue).toISOString();
                    }
                    return simpleFielDefaultValueObj;
                } else {
                    let simpleFieldBothObj = {
                        IsNull: simpleFieldType?.IsNull || false,
                        JoinID: "joinID" in JoinID ? JoinID.joinID : -1,
                        ExpectedType: simpleFieldType.expectedReturnType?.id || simpleFieldType.expectedReturnType,
                        Field: fieldName,
                        DefaultValue: simpleFieldType?.IsNull ? null : defaultValue,
                    };
                    const expectedReturnid = simpleFieldType.expectedReturnType?.id || simpleFieldType.expectedReturnType;
                    if (expectedReturnid === ETLReportingSetReturnTypes.DATE) {
                        // UseNow should be added only for Dates return type
                        simpleFieldBothObj['UseNow'] = UseNow;
                        simpleFieldBothObj.DefaultValue = simpleFieldType?.IsNull ?
                            null : defaultValue == "{{NOW}}" ?
                                defaultValue : new Date(defaultValue).toISOString();
                    }
                    return simpleFieldBothObj;
                }
            case "Regex":
                const { expression } = childs[index] || childs;
                return {
                    Regex: expression,
                    ExpectedType: expectedType,
                    Input: this.getChildObj(children, expectedType),
                };
            case "ComplexString":
                const complexStrings = children.map((_, index) => this.getChildObj(children, expectedType, index))
                return { "StringComponents": complexStrings, "ExpectedType": expectedType };
            case "Coalesce":
                const coalescedFields = children.map((_, index) => this.getChildObj(children, expectedType, index))
                return { "CoalescedFields": coalescedFields, "ExpectedType": expectedType };
            case "Conditional":
                const { negative, positive, operatorDropdown, comparisons } = childs[index] || childs;
                const comparisonsObj = comparisons.map((comparison: ComparisonObject) => {
                    if (comparison.field2.length) {
                        return {
                            CompField: this.getChildObj(comparison.field1[0], expectedType),
                            CompType: ETLReportingSetComparisonTypes[comparison.comparisonType.label],
                            EvalField: this.getChildObj(comparison.field2[0], expectedType),
                        }
                    } else {
                        return {
                            EvalField: this.getChildObj(comparison.field1[0], expectedType),
                            CompType: ETLReportingSetComparisonTypes[comparison.comparisonType.label],
                        }
                    }
                });
                const operatorDropdownLabel = operatorDropdown.label === "AND" ? "And" : "Or";
                return {
                    ExpectedType: expectedType,
                    CompType: 0,
                    [operatorDropdownLabel]: comparisonsObj,
                    PositiveResult: this.getChildObj(positive[0], expectedType),
                    NegativeResult: this.getChildObj(negative[0], expectedType),
                };
            case "ComplexDate":
                const { operation } = childs[index] || childs;
                if (operation.id === ETLReportingSetDateOperationTypes.DATE_DIFFERENCE) {
                    const { leftOperand, rightOperand } = childs[index] || childs;
                    return {
                        AsUnits: "1",
                        ExpectedType: expectedType,
                        LeftOperandField: this.getChildObj(leftOperand[0], expectedType),
                        Operation: `${operation.id}`,
                        RightOperandField: this.getChildObj(rightOperand[0], expectedType),
                    }
                } else {
                    const { leftOperand, days, hours, minutes, months, seconds } = childs[index] || childs;
                    return {
                        AddedUnitValues: {
                            Days: this.getChildObj(days[0], expectedType),
                            Hours: this.getChildObj(hours[0], expectedType),
                            Minutes: this.getChildObj(minutes[0], expectedType),
                            Month: this.getChildObj(months[0], expectedType),
                            Seconds: this.getChildObj(seconds[0], expectedType),
                        },
                        ExpectedType: expectedType,
                        LeftOperandField: this.getChildObj(leftOperand[0], expectedType),
                        Operation: `${operation.id}`,
                    }
                }
            case "ComplexNumeric":
                const { formulas } = childs[index] || childs;

                const formulaComponents = formulas.map((formula: FunctionComponentType, index: number) => {
                    const even = index % 2 === 0;
                    const functionType = formula.functionType as any;
                    const operationType = formula.operations as any;
                    const functionTypeIDTokens = functionType?.id?.split(":")
                    return {
                        FieldExpression: even ? this.getChildObj(formula.childs, expectedType) : null,
                        Function: even && functionTypeIDTokens[0] !== "object" ? +functionTypeIDTokens[1] || 0 : null,
                        Operation: even ? null : +operationType?.id?.split(':')[1] || 0,
                        isEven: even,
                        isFirst: index === 0 ? true : false,
                    }
                })
                return {
                    ExpectedType: expectedType,
                    FormulaComponents: formulaComponents
                }
        }
        if (!children.length) {
            return {};
        }
    }

    convertAndSend(value: number | string | Date): number | string | Date {
        let convertedVal: number | string | Date;
        if (typeof value === 'string') {
            const num: number = parseFloat(value);
            if (isNaN(num)) {
                // Check if it's a date string
                const dateVal: Date = new Date(value);
                if (dateVal.toString() !== 'Invalid Date') {
                    convertedVal = dateVal;
                } else {
                    convertedVal = value;
                }
            } else {
                convertedVal = num;
            }
        } else if (typeof value === 'number') {
            convertedVal = value;
        } else if (typeof value === 'boolean') {
            convertedVal = value;
        } else if (value instanceof Date) {
            // If it's already a Date object
            convertedVal = value;
        } else {
            throw new Error('Unsupported type');
        }
        return convertedVal;
    }

    public showSimpleFieldsModal(headerTitle: string[], listName: string, dataType: string = "") {
        const selectedBaseFeed = this.reportingSetForm?.basefeed?.FeedName;
        this.modalRef = this.dialogSrvc.open(AddSimpleFeedModalComponent, {
            width: "756px",
            height: "553px",
            data: {
                baseFeed: selectedBaseFeed,
                dataType: dataType,
                joinedFeedsList: this.reportingSetJoinedFeedsList,
                advancedVisibility: true,
                headerTitle: headerTitle
            },
        });
        this.modalRef.onClose.subscribe((value) => {
            if (value && value.length > 0) {
                if (listName === this.flowbuilderModules.DATES) {
                    let fieldList = this.convertSimpleFieldsToPaylodFormat(value, ETLPayloadTypes.DATES);
                    this.datesFieldsObjList = fieldList.obj;
                    this.datesFieldNamesList = fieldList.names;
                } else {
                    let fieldList = this.convertSimpleFieldsToPaylodFormat(value, ETLPayloadTypes.DATAFIELDS);
                    this.dataFieldsObjList = fieldList.obj;
                    this.dataFieldNamesList = fieldList.names;
                }
                sendMessageCXOne({ hasNonSavedChanges: true });
            } else {
                this.defaultConfigurationData = {};
                this.isAdvanced = (value === true) ? true : false;
                this.resetDataField.next();
            }
            this.initializeReportingSetPayload();
            this.setDataCountAndCollapseHeader();
            this.selectedSection = (value === true) ? listName : this.flowbuilderModules.DEFAULT;
            this.saveDisabled = true;
            this.isUpdateBtnEnable = false;
            this.isModalClosed = true;
            this.configurePaneActive();
        });
    }

    public configurePaneActive() {
        this.isConfigurationPaneActive =
            this.selectedSection !== this.flowbuilderModules.JOINED_FEEDS &&
            this.selectedSection !== this.flowbuilderModules.DEFAULT &&
            this.isAdvanced;
    }

    public getByDataType(datatype: string) {
        let dataTypes = [
            {
                id: ETLReportingSetReturnTypes.TEXT,
                datatype: "String",
                label: this.getLocalizationString("Text", "Text")
            },
            {
                id: ETLReportingSetReturnTypes.WHOLE_NUMBER,
                datatype: "Integer",
                label: this.getLocalizationString("Whole_Number", "Whole Number")
            },
            {
                id: ETLReportingSetReturnTypes.DECIMAL_NUMBER,
                datatype: "Floating-Point",
                label: this.getLocalizationString("Decimal_Number", "Decimal Number")
            },
            {
                id: ETLReportingSetReturnTypes.TRUE_FALSE,
                datatype: "Boolean",
                label: this.getLocalizationString("True_False", "True/False")
            },
            {
                id: ETLReportingSetReturnTypes.DATE,
                datatype: "Date",
                label: this.getLocalizationString("Date", "Date")
            }
        ]
        return dataTypes.find((item: any) => item.datatype === datatype);
    }

    public deleteAddedField(item: ParentOutputFormType, dataType: "dates" | "data fields") {
        let type = dataType == this.flowbuilderModules.DATES ? this.flowbuilderModules.DATES : this.flowbuilderModules.DATA_FIELDS;
        if (dataType === "dates") {
            this.datesFieldsObjList = this.deleteItemFromList(this.datesFieldsObjList, item);
            this.datesFieldNamesList = this.datesFieldNamesList.filter((datesField) => datesField !== Object.keys(item)[0])
        } else {
            this.dataFieldsObjList = this.deleteItemFromList(this.dataFieldsObjList, item);
            this.dataFieldNamesList = this.dataFieldNamesList.filter((dataField) => dataField !== Object.keys(item)[0])
        }
        this.initializeReportingSetPayload(type);
        this.setDataCountAndCollapseHeader();
        sendMessageCXOne({ hasNonSavedChanges: true });
    }

    public loadFieldsInAllCategories() {
        const res: ETLReportingSetObj = this.cxoneEtlReportingSet.getReportingSetData();
        if (res && Object.keys(res).length > 0) {
            this.dataFieldsObjList = this.convertObjsToDataArray(res.DataFields);
            this.dataFieldNamesList = Object.keys(res.DataFields);

            this.datesFieldsObjList = this.convertObjsToDataArray(res.Dates);
            this.datesFieldNamesList = Object.keys(res.Dates);
            // convert to match 
            const updatedEmpHierarchy = this.mapKeyInObject(res.EmpHierarchy, ETLReportingSetFlowbuilderModules.EMPLOYEE_GROUP, false);
            this.employeeGrpObjList = this.convertObjsToDataArray(updatedEmpHierarchy);
            this.employeeGrpNamesList = Object.keys(updatedEmpHierarchy);
            const updatedContactHierarchy = this.mapKeyInObject(res.ContactHierarchy, ETLReportingSetFlowbuilderModules.CONTACT_GROUP, false);
            this.contactGrpObjList = this.convertObjsToDataArray(updatedContactHierarchy);
            this.contactGrpNamesList = Object.keys(updatedContactHierarchy);

            this.setDataCountAndCollapseHeader();
        }
        if (this.reportingSetForm.hasOwnProperty("editReportingSetData")) {
            this.reportingSetFieldPayload = { ...this.reportingSetForm.editReportingSetData };
        } else {
            this.reportingSetFieldPayload = this.newReportingSetPayload;
            if (this.dataFieldNamesList && this.dataFieldNamesList.length) this.initializeReportingSetPayload("dataFields");
            if (this.datesFieldNamesList && this.datesFieldNamesList.length) this.initializeReportingSetPayload("dates");
        }
    }

    private mapKeyInObject(response: any, category: string, isPayload: boolean): any {
        let hierarchy: any;
        if (isPayload) {
            hierarchy = category === ETLReportingSetFlowbuilderModules.EMPLOYEE_GROUP ? EMPHIERARCHYKEY : CONTACTHIERARCHYKEY;
        } else {
            hierarchy = category === ETLReportingSetFlowbuilderModules.EMPLOYEE_GROUP ? EMPHIERARCHY : CONTACTHIERARCHY;
        }
        const updatedHierarchy = {};
        hierarchy.forEach((key, index) => {
            // Find the key in reportingSetData.EmpHierarchy based on index
            const reportingSetKey = Object.keys(response)[index];
            if (reportingSetKey) {
                // Assign the value to empHierarchyData with the corresponding key from EMPHIERARCHY
                updatedHierarchy[key] = response[reportingSetKey];
            }
        });
        return updatedHierarchy;
    }

    private convertObjsToDataArray(obj) {
        return Object.keys(obj).map(key => ({ [key]: obj[key] }));
    }

    public backtrackReportingPayload(parentPayload, section: string, activeField: string) {
        this.declineAllSubscriptions();
        if ((section === this.flowbuilderModules.DATA_FIELDS) || (section === this.flowbuilderModules.DATES)) {
            this.hierarchyGroupClickedItem = null;
            this.hierarchyEmployeeGroupClickedItem = null;
        }
        if (section === this.flowbuilderModules.EXCLUDE_IF) {
            let isAddBtn = false;
            if (parentPayload) {
                isAddBtn = false;
            } else {
                isAddBtn = true;
            }
            this.excludeIfSection = {
                source: this.flowbuilderModules.EXCLUDE_IF,
                isAdd: isAddBtn
            }
        } else {
            this.excludeIfSection = null;
        }

        this.isModalClosed = false;
        if (this.reportingSetJoined?.reportingSetJoinedFeed.dirty || this.reportingSetDataFieldComponent?.dataFieldForm.dirty) {
            this.declineAllSubscriptions();
            this.showAlertMessage(false);
        } else {
            this.goBackDataFields(parentPayload, section, activeField);
        }
        this.cancelSubjRef = this.cancelAlertSubj.subscribe(() => {
            this.goBackDataFields(parentPayload, section, activeField);
        });
        this.subscriptions.push(this.cancelSubjRef);
        if (this.isConfigurationPaneActive) {
            this.isConfigurationPaneActive = false;
            setTimeout(() => {
                this.isConfigurationPaneActive = true;
            }, 0);
        }
    }

    private goBackDataFields(parentPayload, section: string, activeField: string): void {
        this.cxoneEtlReportingSet.updateData(null);
        if (section === ETLReportingSetFlowbuilderModules.EMPLOYEE_GROUP) {
            this.hierarchyGroupClickedItem = null;
            this.hierarchyEmployeeGroupClickedItem = { group: ETLReportingSetFlowbuilderModules.EMPLOYEE_GROUP, selectedItem: parentPayload.GroupTypeName };
            this.selectedEmployeeGroup = this.hierarchyEmployeeGroupClickedItem.selectedItem;
            parentPayload = parentPayload?.GroupData;
        }
        if (section === ETLReportingSetFlowbuilderModules.CONTACT_GROUP) {
            this.hierarchyEmployeeGroupClickedItem = null;
            this.hierarchyGroupClickedItem = { group: ETLReportingSetFlowbuilderModules.CONTACT_GROUP, selectedItem: parentPayload.GroupTypeName };
            this.selectedContactGroup = this.hierarchyGroupClickedItem.selectedItem;
            parentPayload = parentPayload?.GroupData;
        }
        if (activeField === ETLReportingSetFlowbuilderModules.EMPLOYEE_GROUP) {
            this.selectedEmployeeGroup = section;
            const obj = { ...parentPayload.obj, ...{ saveItem: this.employeeItemSaved } };
            this.hierarchyGroupClickedItem = null;
            this.hierarchyEmployeeGroupClickedItem = JSON.parse(JSON.stringify(obj));
            activeField = null;
            section = ETLReportingSetFlowbuilderModules.EMPLOYEE_GROUP;
            this.parentPayload = null;
            if (this.reportingSetDataFieldComponent) {
                this.reportingSetDataFieldComponent.currentForm = undefined;
                this.reportingSetDataFieldComponent.passDataToForms = undefined;
                this.reportingSetDataFieldComponent.outputForm = undefined;
            }
            this.employeeGroupPayload = {
                reportingSetData: {},
                employeeHierarchyData: parentPayload.employeeHierarchyData,
                selectedSection: this.flowbuilderModules.EMPLOYEE_GROUP
            };
            parentPayload = null;
        }
        if (activeField === ETLReportingSetFlowbuilderModules.CONTACT_GROUP) {
            this.selectedContactGroup = section;
            const obj = { ...parentPayload.obj, ...{ contactSaveItem: this.contactItemSaved } };
            this.hierarchyEmployeeGroupClickedItem = null;
            this.hierarchyGroupClickedItem = JSON.parse(JSON.stringify(obj));
            activeField = null;
            section = ETLReportingSetFlowbuilderModules.CONTACT_GROUP;
            this.parentPayload = null;
            if (this.reportingSetDataFieldComponent) {
                this.reportingSetDataFieldComponent.currentForm = undefined;
                this.reportingSetDataFieldComponent.passDataToForms = undefined;
                this.reportingSetDataFieldComponent.outputForm = undefined;
            }
            this.contactGroupPayload = {
                reportingSetData: {},
                contactGroupData: parentPayload.contactGroupData,
                selectedSection: ETLReportingSetFlowbuilderModules.CONTACT_GROUP
            };
            parentPayload = null;
        }
        this.isConfigurationPaneActive = true;
        this.selectedSection = section;
        this.isAdvanced = true;
        this.selectedSectionItem = activeField;
        this.UNIQUE_ID = 0;
        this.parentPayload = this.convertPayloadBackToParentObject(parentPayload);
        this.currentClickedField = activeField;
    }

    public convertPayloadBackToParentObject(inputObject) {
        if (inputObject) {
            const fieldName = Object.keys(inputObject)[0];
            const fieldData = inputObject[fieldName];
            const result = {
                uniqueId: this.UNIQUE_ID++,
                returnType: this.getReturnTypeObject(+fieldData["ExpectedType"]),
                nestedDataFields: [],
                name: fieldName,
                fieldType: this.getFieldType(fieldData),
                child: this.getFieldTypeChilds(fieldData)
            }
            this.setParentId(result, null);
            return result;
        }
    }

    public getFieldTypeChilds(child) {
        let fieldType = Object.keys(child)[0];
        let fieldData = child[fieldType];

        // for simple fields JoinID is the way to identify it
        if ("JoinID" in child || "DefaultValue" in child) {
            fieldType = "JoinID";
            fieldData = child.hasOwnProperty('JoinID') ? child["JoinID"] : child["DefaultValue"];
        }

        // For Conditional Field type
        if ("CompType" in child) {
            fieldType = "Conditions";
            fieldData = child["And"] ?? child["Or"];
        }

        // For Complex Date Field type
        if ("LeftOperandField" in child) {
            fieldType = "LeftOperandField";
            fieldData = child["LeftOperandField"];
        }

        // For Complex Numeric Field type
        if ("FormulaComponents" in child) {
            fieldType = "FormulaComponents";
            fieldData = child["FormulaComponents"];
        }

        let result: any = {
            parentId: 1,
            uniqueId: this.UNIQUE_ID++,
            type: fieldType,
            name: fieldType,
            childs: [],
        }

        switch (fieldType) {
            case 'Regex':
                result.expression = fieldData;
                result.isExpressionValid = true;
                result.fieldType = this.getFieldType(child);
                result.childs.push(this.getFieldTypeChilds(child.Input));
                break;
            case 'StringComponents':
                result.name = "Complex String";
                result.type = "ComplexString";
                result.fieldType = this.getFieldType(child);
                result.childs = fieldData.map((obj) => this.getFieldTypeChilds(obj));
                break;
            case 'CoalescedFields':
                result.name = result.type = "Coalesce";
                result.fieldType = this.getFieldType(child);
                result.childs = fieldData.map((obj) => this.getFieldTypeChilds(obj));
                break;
            case 'JoinID':
                result.name = `Simple:[${child.Field ?? 'Simple'}]`;
                result.type = "Simple";
                const { label, id } = this.getReturnObjectLabel(child);
                const returnType = +child["ExpectedType"];
                result.fieldType = this.getFieldType(child);
                result.simpleFieldType = {
                    JoinID: {
                        id: fieldData + 1,
                        joinID: fieldData,
                        label: this.getJoinedFeedLabel(fieldData),
                    },
                    isValid: true,
                    expectedReturnType: child['ExpectedType'],
                    return: {
                        id,
                        label
                    }
                };
                if (id === ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD) {
                    result.simpleFieldType.Field = {
                        Name: ConvertFieldTypes[child.Field] ? ConvertFieldTypes[child.Field] : (child.Field || ""),
                        DataType: +child["ExpectedType"],
                        isActive: false,
                        isKey: false,
                        joinName: child.JOINNAME
                    }
                } else if (id === ETLReportingSetSimpleFieldReturnOptions.DEFAULT_VALUE) {
                    result.name = child.DefaultValue + "" || 'Simple:Simple';
                    result.simpleFieldType.IsNull = child.IsNull;
                    result.simpleFieldType.DefaultValue = child.DefaultValue;
                } else {
                    result.simpleFieldType.Field = {
                        Name: ConvertFieldTypes[child.Field] ? ConvertFieldTypes[child.Field] : (child.Field || ""),
                        DataType: +child["ExpectedType"],
                        isActive: false,
                        isKey: false,
                    }
                    result.name = child.DefaultValue || 'Simple:Simple';
                    result.simpleFieldType.IsNull = child.IsNull;
                    result.simpleFieldType.DefaultValue = child.DefaultValue;
                }
                if (returnType === ETLReportingSetReturnTypes.DATE) {
                    result.simpleFieldType.UseNow = child.DefaultValue == "{{NOW}}";
                    if (result.simpleFieldType.UseNow) {
                        result.name = child.DefaultValue;
                        result.simpleFieldType.DefaultValue = child.DefaultValue;
                    } else {
                        result.name = this.convertISODateToSimpleDateFormat(child.DefaultValue) || 'Simple:Simple';
                        result.simpleFieldType.DefaultValue = this.convertISODateToSimpleDateFormat(child.DefaultValue);
                    }
                }
                result.isValid = true;
                result.childs = [];
                break;
            case 'Pattern':
                result.pattern = fieldData;
                result.isPatternValid = true;
                result.name = result.type = "Substring";
                result.fieldType = this.getFieldType(child);
                result.childs.push(this.getFieldTypeChilds(child.Input));
                break;
            case 'Conditions':
                result.positive = [this.getFieldTypeChilds(child.PositiveResult)];
                result.negative = [this.getFieldTypeChilds(child.NegativeResult)];
                let comparisons = fieldData.map((obj) => {
                    let comparisonObj = {
                        comparisonType: {
                            id: obj.CompType,
                            label: this.getComparisonTypeString(obj.CompType),
                            value: this.comparisonTypes[obj.CompType]
                        },
                        field1: [this.getFieldTypeChilds(obj.EvalField)],
                        field2: [],
                    }
                    if ("CompField" in obj) {
                        comparisonObj.field1 = [this.getFieldTypeChilds(obj.CompField)];
                        comparisonObj.field2 = [this.getFieldTypeChilds(obj.EvalField)];
                    }
                    return comparisonObj;
                })
                result.name = result.type = 'Conditional';
                result.operand = 'field1';
                result.operatorDropdown = { label: "And" in child ? "AND" : "OR" };
                result.comparisons = comparisons;
                result.fieldType = this.getFieldType(child);
                result.comparisonForm = comparisons[comparisons.length - 1];
                break;
            case 'LeftOperandField':
                if ("RightOperandField" in child) {
                    result.rightOperand = [this.getFieldTypeChilds(child.RightOperandField)];
                    result.operand = 'rightOperand';
                } else {
                    result.days = [this.getFieldTypeChilds(child.AddedUnitValues.Days)];
                    result.hours = [this.getFieldTypeChilds(child.AddedUnitValues.Hours)];
                    result.minutes = [this.getFieldTypeChilds(child.AddedUnitValues.Minutes)];
                    result.months = [this.getFieldTypeChilds(child.AddedUnitValues.Month)];
                    result.seconds = [this.getFieldTypeChilds(child.AddedUnitValues.Seconds)];
                    result.operand = 'months';
                }
                result.leftOperand = [this.getFieldTypeChilds(child.LeftOperandField)];
                result.fieldType = this.getFieldType(child);
                result.type = 'ComplexDate';
                result.name = 'Complex Date';

                result.operation = {
                    id: +child.Operation,
                    label: Number(child.Operation) === 0 ? "Add Subtract Unit" : "Date Difference",
                };
                break;
            case 'FormulaComponents':
                result.fieldType = { id: 'Complex Numeric', label: 'Complex Numeric', type: 'ComplexNumeric', orderId: ETLReportingSetFieldTypesId.COMPLEX_NUMERIC };
                result.formulas = child.FormulaComponents.map((formulaComponent: FunctionPayloadType, index: number) => {
                    const isEven = index % 2 === 0;
                    const functionTypeID = formulaComponent.Function === null ? `object:null` : `number:${formulaComponent.Function}`;
                    const operationsTypeID = `number:${formulaComponent.Operation}`;
                    return {
                        childs: formulaComponent.FieldExpression ? [this.getFieldTypeChilds(formulaComponent.FieldExpression)] : [],
                        functionType: isEven ? { id: functionTypeID, label: this.getKeyByValue(ETLReportingSetFunctionTypes, functionTypeID) } : "",
                        numericType: isEven ? "expression" : "operation",
                        operations: isEven ? "" : { id: operationsTypeID, label: this.getKeyByValue(ETLReportingSetOperationTypes, operationsTypeID).split("_").join(" ") }
                    }
                });
                result.name = 'Complex Numeric';
                result.type = 'ComplexNumeric';
                break;
        }
        return result;
    }

    public getFieldType(fieldData) {
        let result = { id: '', label: '', orderId: -1, permissions: [] }
        if ("JoinID" in fieldData || "DefaultValue" in fieldData) {
            result.id = result.label = "Simple";
            result.orderId = ETLReportingSetFieldTypesId.SIMPLE;
            result.permissions = [0, 1, 2, 3, 4];
        } else if ("Conditions" in fieldData || "PositiveResult" in fieldData) {
            result.id = result.label = "Conditional";
            result.orderId = ETLReportingSetFieldTypesId.CONDITIONAL;
            result.permissions = [0, 1, 2, 3, 4];
        } else if ("LeftOperandField" in fieldData) {
            result.id = result.label = "Complex Date";
            result.orderId = ETLReportingSetFieldTypesId.COMPLEX_DATE;
        } else if ("FormulaComponents" in fieldData) {
            result.id = result.label = "Complex Numeric";
            result.orderId = ETLReportingSetFieldTypesId.COMPLEX_NUMERIC;
        } else if ("Regex" in fieldData) {
            result.id = result.label = "Regex";
            result.orderId = ETLReportingSetFieldTypesId.REGEX;
        } else if ("StringComponents" in fieldData) {
            result.id = result.label = "Complex String";
            result.orderId = ETLReportingSetFieldTypesId.COMPLEX_STRING;
        } else if ("CoalescedFields" in fieldData) {
            result.id = result.label = "Coalesce";
            result.orderId = ETLReportingSetFieldTypesId.COALESCE;
        } else if ("Pattern" in fieldData) {
            result.id = result.label = "Substring";
            result.orderId = ETLReportingSetFieldTypesId.SUBSTRING;
        }
        return result;
    }

    private getJoinedFeedLabel(joinID: number) {
        if (joinID === -1) {
            return this.feedName;
        } else {
            const filteredList = this.reportingSetJoinedFeedsList.filter((list) => {
                return list.JoinID === joinID;
            });
            if (filteredList.length > 0) {
                const { joinedFeedName } = filteredList.pop();
                if (joinedFeedName) {
                    return joinedFeedName;
                }
            }
        }
    }

    private getReturnTypeObject(expectedType: number) {
        let returnObj: ETLReportingSetDropdownOptions = { id: -1, label: "" };
        switch (expectedType) {
            case ETLReportingSetReturnTypes.TEXT:
                returnObj.id = expectedType;
                returnObj.label = "Text";
                break;
            case ETLReportingSetReturnTypes.WHOLE_NUMBER:
                returnObj.id = expectedType;
                returnObj.label = "Whole Number";
                break;
            case ETLReportingSetReturnTypes.DECIMAL_NUMBER:
                returnObj.id = expectedType;
                returnObj.label = "Decimal Number";
                break;
            case ETLReportingSetReturnTypes.DATE:
                returnObj.id = expectedType;
                returnObj.label = "Date";
                break;
            case ETLReportingSetReturnTypes.TRUE_FALSE:
                returnObj.id = expectedType;
                returnObj.label = "True/False";
                break;
        }
        return returnObj;
    }

    private getReturnObjectLabel(obj) {
        let label = "";
        let id = -1;
        if ("Field" in obj && "DefaultValue" in obj && obj.Field !== "") {
            label = this.getLocalizationString("Specific_Field_And_Default_Value", "Specific Field And Default Value");
            id = ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD_AND_DEFAULT_VALUE;
        } else if ("Field" in obj && obj.Field !== "") {
            label = this.getLocalizationString("Specific_Field", "Specific Field");
            id = ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD;
        } else {
            label = this.getLocalizationString("Default_Value", "Default Value");
            id = ETLReportingSetSimpleFieldReturnOptions.DEFAULT_VALUE;
        }
        return { label, id };
    }

    setParentId(obj, parentId) {
        if (obj.hasOwnProperty('uniqueId')) {
            obj.parentId = parentId;
        }
        if (obj.hasOwnProperty('child')) {
            this.setParentId(obj.child, obj.uniqueId);
        }
        if (obj.hasOwnProperty('childs')) {
            for (let i = 0; i < obj.childs.length; i++) {
                this.setParentId(obj.childs[i], obj.uniqueId);
            }
            if (obj.childs.length === 0) {
                const fieldsToCheck = DataFlowSubFields;
                fieldsToCheck.forEach(field => {
                    if (obj.hasOwnProperty(field)) {
                        if (field === 'comparisons') {
                            for (let i = 0; i < obj[field].length; i++) {
                                this.setParentId(obj[field][i], obj.uniqueId);
                                const element = obj[field][i];
                                if (element?.field1?.length > 0) {
                                    this.setParentId(element?.field1[0], obj.uniqueId);
                                }
                                if (element?.field2?.length > 0) {
                                    this.setParentId(element?.field2[0], obj.uniqueId);
                                }
                            }
                        } else {
                            for (let i = 0; i < obj[field].length; i++) {
                                this.setParentId(obj[field][i], obj.uniqueId);
                            }
                        }
                    }
                });
            }
        }
    }

    private getComparisonTypeString(value: number): string | undefined {
        const entry = Object.entries(ETLReportingSetComparisonTypes).find(([, v]) => v === value);
        return entry ? entry[0] : undefined;
    }

    public handleSave() {
        const selectedSection = this.selectedSection;
        switch (this.selectedSection) {
            case "dataFields":
                this.isAdvanced && this.createFieldPayloadObject(this.parentPayload || this.payloadData);
                const dataFieldName = Object.keys(this.parentOutputForm)[0];
                if (this.dataFieldNamesList.includes(this.currentClickedField)) {
                    this.dataFieldsObjList = this.replaceDuplicateField(this.dataFieldsObjList, this.currentClickedField, this.parentOutputForm);
                    if (dataFieldName !== this.currentClickedField) {
                        this.dataFieldNamesList = [...this.dataFieldNamesList, ...[dataFieldName]];
                        this.dataFieldNamesList = Array.from(new Set(this.dataFieldNamesList.filter((field) => field !== this.currentClickedField)));
                    }
                }
                else {
                    this.dataFieldsObjList.push(this.parentOutputForm);
                    this.dataFieldNamesList = [...this.dataFieldNamesList, ...[dataFieldName]];
                }
                this.dataFieldsObjList = this.syncDataFieldObjectsWithItems(this.dataFieldsObjList, this.dataFieldNamesList);
                // this function will prepare the reportingSetPayload data for submission
                this.initializeReportingSetPayload();
                this.resetPayloadData();
                let _dataFieldObj = {};
                let _dataFieldName = "";
                this.dataFieldsObjList.forEach((dfol: ParentOutputFormType) => {
                    if (Object.keys(dfol)[0] === dataFieldName) {
                        _dataFieldName = dataFieldName;
                        _dataFieldObj = dfol;
                        return;
                    }
                });
                this.backtrackReportingPayload(_dataFieldObj, this.flowbuilderModules.DATA_FIELDS, _dataFieldName);
                break;
            case "dates":
                this.isAdvanced && this.createFieldPayloadObject(this.parentPayload || this.payloadData);
                const datesFieldName = Object.keys(this.parentOutputForm)[0];
                if (this.datesFieldNamesList.includes(this.currentClickedField)) {
                    this.datesFieldsObjList = this.replaceDuplicateField(this.datesFieldsObjList, this.currentClickedField, this.parentOutputForm);
                    if (datesFieldName !== this.currentClickedField) {
                        this.datesFieldNamesList = [...this.datesFieldNamesList, ...[datesFieldName]];
                        this.datesFieldNamesList = Array.from(new Set(this.datesFieldNamesList.filter((field) => field !== this.currentClickedField)));
                    }
                }
                else {
                    this.datesFieldsObjList.push(this.parentOutputForm);
                    this.datesFieldNamesList = [...this.datesFieldNamesList, ...[datesFieldName]];
                }
                this.datesFieldsObjList = this.syncDataFieldObjectsWithItems(this.datesFieldsObjList, this.datesFieldNamesList);
                this.initializeReportingSetPayload();
                this.resetPayloadData();
                let _dateFieldObj = {};
                let _dateFieldName = "";
                this.datesFieldsObjList.forEach((dfol: ParentOutputFormType) => {
                    if (Object.keys(dfol)[0] === datesFieldName) {
                        _dateFieldName = datesFieldName;
                        _dateFieldObj = dfol;
                        return;
                    }
                });
                this.backtrackReportingPayload(_dateFieldObj, this.flowbuilderModules.DATES, _dateFieldName);
                break;
            case "joinedFeeds":
                this.addReportingsetJoinedFeeds(true);
                this.setJoinedFeed(this.joinedfeedCurrentItem)
                this.reportingSetJoined?.reportingSetJoinedFeed.markAsPristine();
                this.reportingSetJoined?.reportingSetJoinedFeed.markAsUntouched();
                break;
            case "employeeGroup":
                this.createFieldPayloadObject(this.parentPayload || this.payloadData);
                const employeeGrpKey = Object.keys(this.parentOutputForm)[0];
                if (this.employeeGrpNamesList.includes(employeeGrpKey)) {
                    this.employeeGrpObjList = this.replaceDuplicateField(this.employeeGrpObjList, employeeGrpKey, this.parentOutputForm);
                    this.employeeGrpNamesList = Array.from(new Set(this.employeeGrpNamesList));
                } else {
                    this.employeeGrpObjList.push(this.parentOutputForm);
                    this.employeeGrpNamesList.push((Object.keys(this.parentOutputForm)[0]));
                }
                if (this.employeeGroupComponent) {
                    this.employeeItemSaved[this.selectedEmployeeGroup] = true;
                    this.employeeGroupComponent.setEmployeeGroupPayload(this.parentOutputForm, this.selectedEmployeeGroup);
                }
                this.initializeReportingSetPayload();
                this.resetPayloadData();
                this.handleCreateBtn(employeeGrpKey, "employee");
                break;
            case "contactGroup":
                this.createFieldPayloadObject(this.parentPayload || this.payloadData);
                const contactGrpKey = Object.keys(this.parentOutputForm)[0];
                if (this.contactGrpNamesList.includes(contactGrpKey)) {
                    this.contactGrpObjList = this.replaceDuplicateField(this.contactGrpObjList, contactGrpKey, this.parentOutputForm);
                    this.employeeGrpNamesList = Array.from(new Set(this.contactGrpNamesList));
                } else {
                    this.contactGrpObjList.push(this.parentOutputForm);
                    this.contactGrpNamesList.push((Object.keys(this.parentOutputForm)[0]));
                }
                if (this.contactGroupComponent) {
                    let contactItem = this.selectedContactGroup.replace(/\s/g, '');
                    this.contactItemSaved[contactItem] = true;
                    this.contactGroupComponent.setContactGroupPayload(this.parentOutputForm, this.selectedContactGroup);
                }
                this.initializeReportingSetPayload();
                this.resetPayloadData();
                this.handleCreateBtn(contactGrpKey, 'contact');
                break;
            case "excludeIf":
                this.addExclude(this.parentPayload || this.payloadData);
                this.initializeReportingSetPayload();
                this.resetPayloadData();
                break;
        }
        this.setDataCountAndCollapseHeader();
        this.saveDisabled = true;
        this.isUpdateBtnEnable = false;
        this.selectedSection = selectedSection;
    }

    private replaceDuplicateField(fieldsObj: Array<ParentOutputFormType>, fieldLabel: string, newEntry: ParentOutputFormType): ParentOutputFormType[] {
        let result: ParentOutputFormType[] = [];
        fieldsObj.forEach((fieldObj) => {
            const key = Object.keys(fieldObj)[0];
            if (key !== fieldLabel) {
                result.push(fieldObj);
            }
        })
        result.push(newEntry);
        return result;
    }

    private resetPayloadData() {
        this.resetDataField.next();
        this.reportingSetDataFieldComponent?.dataFieldForm.markAsPristine();
        this.reportingSetDataFieldComponent?.dataFieldForm.markAsUntouched();
        this.parentOutputForm = {};
    }

    public getFieldsIsValid(payload: DatesParentDataType): boolean {
        let childs = payload.childs;
        let isValid = payload.isValid;
        if (isValid === undefined) {
            isValid = true;
        }
        if (!isValid) {
            return false;
        } else {
            if (childs.length) {
                childs.map((child) => {
                    this.getFieldsIsValid(child);
                });
            } else {
                const simpleFieldType = payload.simpleFieldType;
                if (!simpleFieldType.isValid) {
                    return false;
                }
            }
        }
        return true;
    }
    
    public convertSimpleFieldsToPaylodFormat(simpleFieldsList: Array<SimpleFieldModalType>, datatype: "dates" | "datafields") {
        this.fieldsList = datatype == ETLPayloadTypes.DATES ? this.datesFieldsObjList : this.dataFieldsObjList;
        this.fieldNames = datatype == ETLPayloadTypes.DATES ? this.datesFieldNamesList : this.dataFieldNamesList;
        simpleFieldsList.forEach((simpleField) => {
            const { isPresent, duplicateCount } = this.isSimpleFieldAlreadyPresent(simpleField);
            let fieldName = simpleField.FIELDS;
            if (isPresent) {
                // Space is added to meet UX requirement 
                fieldName += ` ${duplicateCount + 1}`;
            }
            let fieldObj = {
                [fieldName]: {
                    ExpectedType: this.getByDataType(simpleField["DATA TYPE"]).id.toString(),
                    Field: simpleField.FIELDS,
                    JOINNAME: simpleField.JOINNAME,
                    JoinID: simpleField.JOINID,
                }
            }
            this.fieldNames.push(fieldName);
            this.fieldsList.push(fieldObj);
        });
        return { obj: this.fieldsList, names: this.fieldNames };
    }

    public isSimpleFieldAlreadyPresent(simpleField: SimpleFieldModalType) {
        const duplicateCount = this.fieldNames.filter((item: string) => item.includes(simpleField.FIELDS)).length;
        return { isPresent: duplicateCount > 0, duplicateCount };
    }

    public deleteItemFromList(itemList: Array<ParentOutputFormType>, itemToBeRemoved: ParentOutputFormType) {
        const indexToRemove = itemList.findIndex(obj => {
            const key = Object.keys(obj)[0];
            const targetKey = Object.keys(itemToBeRemoved)[0];
            return key === targetKey && JSON.stringify(obj[key]) === JSON.stringify(itemToBeRemoved[targetKey]);
        });
        
        if (indexToRemove !== -1) {
            itemList.splice(indexToRemove, 1);
        }
        return itemList;
    }

    private getKeyByValue(object, value: string) {
        return Object.keys(object).find(key => object[key] === value);
    }

    public assignDatafieldsData(data: any) {
        if (data && data.length) {
            let obj = {
                datesFieldNamesList: [],
                dataFieldNamesList: []
            }

            data.forEach((element: any) => {
                if (element["DATA TYPE"] === "Date")
                    obj.datesFieldNamesList.push(element)
                else
                    obj.dataFieldNamesList.push(element);
            });

            if (obj.datesFieldNamesList.length) {
                let fieldList = this.convertSimpleFieldsToPaylodFormat(obj.datesFieldNamesList, ETLPayloadTypes.DATES);
                this.datesFieldsObjList = fieldList.obj;
                this.datesFieldNamesList = fieldList.names;
            }

            if (obj.dataFieldNamesList.length) {
                let fieldList = this.convertSimpleFieldsToPaylodFormat(obj.dataFieldNamesList, ETLPayloadTypes.DATAFIELDS);
                this.dataFieldsObjList = fieldList.obj;
                this.dataFieldNamesList = fieldList.names;
            }

            this.setDataCountAndCollapseHeader();
        }
    }

    addExclude(data) {
        if (data) {
            this.excludeIf = false;
            this.createFieldPayloadObject(data);
            this.initializeReportingSetPayload();
            this.reportingSetDataFieldComponent.dataFieldForm.markAsPristine();
            this.editExcludeIf();
        } else {
            this.backtrackReportingPayload(null, 'excludeIf', null);
        }
    }

    editExcludeIf() {
        let ExcludeIf = {
            ExcludeIf: { ...this.reportingSetFieldPayload.ExcludeIf }
        };
        this.backtrackReportingPayload(ExcludeIf, 'excludeIf', null);
    }

    setFormFromTree(item) {
        if (!item.form.hasOwnProperty('type') && (item.form.nodeLabel === 'True' || item.form.nodeLabel === 'False' || item.form.nodeLabel === "")) {
            if (this.reportingSetDataFieldComponent.conditionalComponent) {
                if (item.form.nodeLabel != "") {
                    const operand = item.form.nodeLabel === 'True' ? "positive" : "negative";
                    this.reportingSetDataFieldComponent.conditionalComponent.addNewField(operand);
                } else {
                    this.reportingSetDataFieldComponent.goBack(item?.form.parentId);
                }
            } else {
                this.reportingSetDataFieldComponent.goBack(item?.form.parentId);
                if (item.form.nodeLabel != "") {
                    setTimeout(() => {
                        const operand = item.form.nodeLabel === 'True' ? "positive" : "negative";
                        this.reportingSetDataFieldComponent.conditionalComponent.addNewField(operand);
                    }, 10);
                }
            }
        } else {
            this.reportingSetDataFieldComponent.goBack(item?.form.uniqueId);
        }
    }

    handleSaveBtn(isValid: boolean) {
        let formChanged = this.reportingSetJoined?.reportingSetJoinedFeed.dirty ||
            (this.reportingSetDataFieldComponent?.dataFieldForm.dirty && this.reportingSetDataFieldComponent?.dataFieldForm.valid);
        let saveDisabled = true;
        switch (this.selectedSection) {
            case ETLReportingSetFlowbuilderModules.JOINED_FEEDS:
                saveDisabled = !isValid;
                break;
            case ETLReportingSetFlowbuilderModules.DATES:
            case ETLReportingSetFlowbuilderModules.DATA_FIELDS:
            case ETLReportingSetFlowbuilderModules.CONTACT_GROUP:
            case ETLReportingSetFlowbuilderModules.EMPLOYEE_GROUP:
            case ETLReportingSetFlowbuilderModules.EXCLUDE_IF:
                saveDisabled = !isValid;
                break;
            default:
                saveDisabled = false;
                break;
        }
        this.saveDisabled = !formChanged || saveDisabled;
    }

    handleCreateBtn(data: string, grpName: 'employee' | 'contact') {
        if (!this.groupsValidationCheck[grpName].includes(data)) {
            this.groupsValidationCheck[grpName].push(data);
        }
        this.verifyGroups();
    }

    verifyGroups() {
        if (this.groupsValidationCheck['employee'].length == 3 && this.groupsValidationCheck['contact'].length == 4) {
            this.createDisabled = false;
        }
    }

    async postReportingSetData(isCreate: boolean) {
        this.isSaving = true;
        this.reportingSetFieldPayload = this.updatedReportingSetFieldPayload();
        try {
            const response = await this.cxoneEtlReportingSet.createReportingSetDefination(this.reportingSetFieldPayload);
            if (response.status === STATUS.SUCCESS) {
                const isResponseValid = response.data['Valid'];
                const memos = response.data['Memos'];
                const dialogData = {
                    title: this.getLocalizationString("Error", "Error"),
                    type: "system-error",
                    message: this.generateMessageHtml(memos),
                    primaryButtonText: this.getLocalizationString("Close", "Close"),
                    closeButtonText: null,
                };
                if (!isResponseValid) {
                    const ref = this.dialogSrvc.open(MessageModalComponent, {
                        width: "500px",
                        height: "440px",
                        styleClass: "cx-one-ui modal-center testing",
                        data: dialogData,
                    });
                } else if (isCreate) {
                    this.toasterManager.showToaster("success",
                        this.getLocalizationString("Create_Reporting_Set_Successful", "Reporting set created successfully."));
                    this.sectionChange.emit(this.reportingSetSections.LIST);
                } else if (!isCreate) {
                    this.toasterManager.showToaster("success",
                        this.getLocalizationString("Create_Reporting_Set_Successful", "Reporting set updated successfully."));
                    this.sectionChange.emit(this.reportingSetSections.LIST);
                }
            }
        } catch (error) {
            if (error.status === STATUS.FAILURE) {
                this.toasterManager.showToaster("error", this.getLocalizationString("Error", error.warnings[0]));
            }
        }
        this.isSaving = false;
        sendMessageCXOne({ hasNonSavedChanges: false });
    }

    generateMessageHtml(memos: any): string {
        let html = '';
        for (const key of Object.keys(memos)) {
            html += `
            <div>
                <h6>${key}</h6>
                <ul>
                    ${memos[key].map(item => `<li>${item}</li>`).join('')}
                </ul>
            </div>
          `;
        }
        return html;
    }

    // This function will order the objects inside objList based on itemsList elements
    syncDataFieldObjectsWithItems(objList: ParentOutputFormType[], itemsList: string[]) {
        const mapping = {};
        objList.forEach(obj => {
            for (const key in obj) {
                mapping[key] = obj[key];
            }
        });
        const syncedList = itemsList.map(str => ({
            [str]: mapping[str] || {}
        }));
        return syncedList;
    }

    buildedForm(e) {
        window.requestAnimationFrame(() => {
            if (this.treeBuilderComponent && e && e.hasOwnProperty('child')) {
                this.buildTreeFromForm();
            }
            if (this.treeBuilderComponent && this.treeBuilderComponent.lines.length > 0) {
                this.treeBuilderComponent.lines[0].form.name = e.name;
            }
        })
    }

    buildTreeFromForm() {
        this.treeBuilderComponent.buildTreeStructure(null);
        this.showTreebuilder = false;
        setTimeout(() => {
            this.showTreebuilder = true;
            window.requestAnimationFrame(() => {
                if (this.treeBuilderComponent) {
                    this.treeBuilderComponent.lines = [];
                    this.treeBuilderComponent.buildTreeStructure(this.reportingSetDataFieldComponent.outputForm);
                }
            })
        }, 0);
    }

    childFormsChanged(item) {
        if ((item.type === "Conditional" || item.type === "ComplexNumeric" || item.type === "ComplexDate") && this.treeBuilderComponent) {
            this.buildTreeFromForm();
        } else if (this.treeBuilderComponent) {
            const isTreeValid = this.treeBuilderComponent.validateAllTreeForms();
            if (isTreeValid !== undefined) {
                this.handleSaveBtn(isTreeValid);
            }
        }
    }

    validateSaveBtn(item) {
        if (this.treeBuilderComponent) {
            const isTreeValid = this.treeBuilderComponent.validateAllTreeForms();
            if (isTreeValid !== undefined) {
                this.handleSaveBtn(isTreeValid);
            }
        }
    }

    setDataCountAndCollapseHeader() {
        this.joinedFeedsHeader = this.getLocalizationString("Joined_Feeds", "JOINED FEEDS") + ` (${this.reportingSetJoinedFeedsList.length})`;
        this.datesHeader = this.getLocalizationString("Dates", "DATES") + ` (${this.datesFieldNamesList.length})`;
        this.dataFieldsHeader = this.getLocalizationString("Data_Fields", "DATA FIELDS") + ` (${this.dataFieldNamesList.length})`;
    }

    updatedReportingSetFieldPayload() {
        let data = {
            ReportingSetName: this.reportingSetName,
            ReportingSetDescription: this.reportingSetForm.description,
            ReportingSetGroup: this.category,
            BaseFeed: this.reportingSetForm.basefeed.FeedName,
        }
        return { ...this.reportingSetFieldPayload, ...data };
    }

    convertISODateToSimpleDateFormat(dateString: string) {
        const date = new Date(dateString);
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };
        return date.toLocaleDateString('en-us', options);
    }

    public redirectToCreateEdit(section: number): void {
        this.sectionChange.emit(section);
    }

    declineAllSubscriptions() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    validateNameField($event: any): void {
        if ($event.isNameExist) {
            this.saveDisabled = $event.isNameExist;
        }
        if ($event.isNameError) {
            this.saveDisabled = $event.isNameError;
        }
    }
}
